// --------------------------------------------------
// FILTER SLIDER NAVIGATION
// --------------------------------------------------

(function() {
  const slider = document.querySelector('.filter-slider__track');
  if (!slider) return;

  const btnPrev = document.querySelector('.filter-slider__prev');
  const btnNext = document.querySelector('.filter-slider__next');

  const slideAmount = 260;

  btnPrev?.addEventListener('click', () => {
    slider.scrollBy({ left: -slideAmount, behavior: 'smooth' });
  });

  btnNext?.addEventListener('click', () => {
    slider.scrollBy({ left: slideAmount, behavior: 'smooth' });
  });

  // Mouse Drag (desktop)
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', e => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    slider.classList.add('dragging');
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('dragging');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('dragging');
  });

  slider.addEventListener('mousemove', e => {
    if (!isDown) return;
    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5;
    slider.scrollLeft = scrollLeft - walk;
  });

  // Mobile swipe (touch)
  slider.addEventListener('touchstart', e => {
    startX = e.touches[0].pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('touchmove', e => {
    const x = e.touches[0].pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.2;
    slider.scrollLeft = scrollLeft - walk;
  });
})();

// --------------------------------------------------
// SHOW/HIDE SLIDER ARROWS WHEN NEEDED
// --------------------------------------------------

function updateFilterSliderArrows() {
  const slider = document.querySelector('.filter-slider__track');
  const prev = document.querySelector('.filter-slider__prev');
  const next = document.querySelector('.filter-slider__next');

  if (!slider || !prev || !next) return;

  const hasOverflow = slider.scrollWidth > slider.clientWidth + 2;

  if (hasOverflow) {
    prev.style.display = 'flex';
    next.style.display = 'flex';
  } else {
    prev.style.display = 'none';
    next.style.display = 'none';
  }
}

// run when page loads
document.addEventListener('DOMContentLoaded', updateFilterSliderArrows);

// run when viewport changes
window.addEventListener('resize', () => {
  updateFilterSliderArrows();
  setTimeout(updateFilterSliderArrows, 150);
});

// --------------------------------------------------
// ACTIVE FILTER CARD + SCROLL TO FILTER SLIDER
// --------------------------------------------------

function normalizeQuery(queryString) {
  if (!queryString) return '';

  const params = new URLSearchParams(queryString.replace(/^\?/, ''));
  const pairs = [];

  for (const [key, value] of params.entries()) {
    // Ignore pagination and sorting params
    if (key === 'page' || key === 'sort_by') continue;

    pairs.push(`${key}=${value}`);
  }

  pairs.sort();
  return pairs.join('&');
}

function setActiveFilterCard() {
  const currentQuery = normalizeQuery(window.location.search);
  const cards = document.querySelectorAll('.filter-card[data-filter-query]');

  cards.forEach(card => {
    const cardQuery = normalizeQuery(card.dataset.filterQuery || '');
    card.classList.remove('active');

    if (cardQuery === currentQuery) {
      card.classList.add('active');
    }
  });
}

function scrollToFilterSliderIfNeeded() {
  if (!window.location.search) return;

  const slider = document.getElementById('collection-filters');
  if (!slider) return;

  const header = document.querySelector('.site-header, .header-wrapper, .header-sticky');
  const offset = header ? header.offsetHeight + 12 : 80;

  const rect = slider.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const targetY = rect.top + scrollTop - offset;

  window.scrollTo({
    top: targetY,
    behavior: 'smooth'
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setActiveFilterCard();

  // If there is a filter in the URL, scroll back to the slider
  if (window.location.hash === '#collection-filters' || window.location.search) {
    setTimeout(() => {
      scrollToFilterSliderIfNeeded();
    }, 80);
  }
});

// --------------------------------------------------
// DESCRIPTION TOGGLE
// --------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.collection-description-wrapper');
  if (!wrapper) return;

  var desc = wrapper.querySelector('.collection__description');
  var btn = wrapper.querySelector('.toggle-description-btn');

  if (desc.scrollHeight <= desc.clientHeight) {
    btn.style.display = 'none';
    return;
  }

  btn.addEventListener('click', function () {
    var expanded = desc.classList.toggle('expanded');
    btn.textContent = expanded ? 'See Less' : 'See More';
  });
});

// --------------------------------------------------
// OUT OF STOCK LABEL ON BUNDLE PARENT PRODUCTS
// --------------------------------------------------

(function () {
  'use strict';

  const CARD_SELECTOR = '.grid-product[data-bundle-base="true"]';
  const CACHE_KEY = 'bundle_oos_handles_v1';
  const TTL = 5 * 60 * 1000; // 5 minutes
  const ENDPOINT = '/collections/bundle-items-oos?view=bundle-items-json';

  async function getOosSet() {
    let oosSet = null;

    try {
      const cached = sessionStorage.getItem(CACHE_KEY);

      if (cached) {
        const parsed = JSON.parse(cached);

        if (
          parsed &&
          Array.isArray(parsed.handles) &&
          parsed.time &&
          (Date.now() - parsed.time < TTL)
        ) {
          oosSet = new Set(parsed.handles);
        }
      }
    } catch (e) {
      // Ignore cache errors
    }

    if (oosSet) return oosSet;

    const res = await fetch(ENDPOINT, { credentials: 'same-origin' });
    const data = await res.json();

    const handles = Object.keys(data || {});
    oosSet = new Set(handles);

    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        handles: handles,
        time: Date.now()
      }));
    } catch (e) {
      // Ignore storage errors
    }

    return oosSet;
  }

  function markParentAsOos(card) {
    card.classList.add('is-sold-out');

    // avoid duplicate
    if (card.querySelector('.grid-product__tag--sold-out')) return;

    const label = document.createElement('div');
    label.className = 'grid-product__tag grid-product__tag--sold-out';
    label.textContent = 'Sold Out';

    const container = card.querySelector('.grid-product__content');

    if (container) {
      container.appendChild(label);
    } else {
      card.appendChild(label); // fallback
    }
  }

  function processCards(oosSet) {
    const cards = document.querySelectorAll(CARD_SELECTOR);

    cards.forEach(function (card) {
      if (card.classList.contains('stock-checked')) return;

      const handles = (card.dataset.bundleHandles || '')
        .split(',')
        .map(function (h) { return h.trim(); })
        .filter(Boolean);

      if (!handles.length) {
        card.classList.add('stock-checked', 'stock-ready');
        return;
      }

      const allOos = handles.every(function (handle) {
        return oosSet.has(handle);
      });

      if (allOos) {
        markParentAsOos(card);
      }

      card.classList.add('stock-checked', 'stock-ready');
    });
  }

  document.addEventListener('DOMContentLoaded', async function () {
    const cards = document.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    try {
      const oosSet = await getOosSet();
      processCards(oosSet);
    } catch (e) {
      document.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
        card.classList.add('stock-ready');
      });
      console.warn('Bundle OOS check failed', e);
    }
  });
})();